import { TFilterKey } from '@app.feature/activityFilter/modules/constant'
import { upsertOrderByKey, upsertOrderMultipleByKeys } from '../module/order'
import { TActivityFilterItem, TStoreSlice } from '../storeActivityFilter'

export type TSelectSlice = {
  selectedFilter: {
    [key in TFilterKey]: TActivityFilterItem[]
  }
  updateSelectedFilter: (options: {
    name: TFilterKey
    filters: TActivityFilterItem[]
  }) => void
  addSelectedFilter: (options: {
    name: TFilterKey
    filter: TActivityFilterItem
  }) => void
  removeSelectedFilter: (options: {
    name: TFilterKey
    filterId: string
  }) => void
  resetSelectedFilter: () => void
}

const INIT_SELECTED_FILTER: {
  [key in TFilterKey]: TActivityFilterItem[]
} = {
  categoryIDs: [],
  jobTypes: [],
  orgTypeIDs: [],
  regionIDs: [],
  benefitIDs: [],
  interestIDs: [],
  period: [],
  reward: [],
  targetIDs: [],
  internTypeIds: [],
}

const createSelectSlice: TStoreSlice<TSelectSlice> = (set, get) => ({
  selectedFilter: INIT_SELECTED_FILTER,
  updateSelectedFilter: ({ name, filters }) => {
    const { order, orderMap } = get()
    const orderStore = upsertOrderMultipleByKeys({
      order,
      orderMap,
      target: {
        dataKey: name,
        ids: filters.map(({ id }) => id),
      },
    })
    set((state) => ({
      selectedFilter: {
        ...state.selectedFilter,
        [name]: filters,
      },
      ...orderStore,
    }))
  },
  addSelectedFilter: ({ name, filter }) => {
    const { order, orderMap } = get()
    const orderStore = upsertOrderByKey({
      order,
      orderMap,
      key: `${name}.${filter.id}`,
    })
    set((state) => ({
      selectedFilter: {
        ...state.selectedFilter,
        [name]: [...state.selectedFilter[name], filter],
      },
      ...orderStore,
    }))
  },
  removeSelectedFilter: ({ name, filterId }) => {
    set((state) => ({
      selectedFilter: {
        ...state.selectedFilter,
        [name]: state.selectedFilter[name].filter(({ id }) => id !== filterId),
      },
    }))
  },
  resetSelectedFilter: () => {
    set(() => ({
      selectedFilter: INIT_SELECTED_FILTER,
    }))
  },
})

export default createSelectSlice
